import { IRoute } from '../routes/routes';
import { subYears } from 'date-fns';
import moment from 'moment';
import * as Yup from 'yup';
import { Member, useGenerate_Signeds3_Request_For_UploadMutation } from '../generated/graphql';
import { get } from 'lodash';

export function getInitials(name: string): string {
  const [firstName, lastName] = name.split(' ');
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`;
  }

  return firstName[0];
}

export function getDate18YearsAgo() {
  return subYears(new Date(), 18);
}

export function formatDuration(years?: number, months?: number) {
  let durationString = '';
  if (years && years > 0) {
    durationString = `${years} years `;
  }

  if (months && months > 0) {
    durationString = `${durationString}${months} months`;
  }

  return durationString;
}

export function getIdImageName(
  id: number,
  ext: string,
  firstName?: string | null,
  lastName?: string | null
) {
  let name = '';

  if (firstName) {
    name = `${firstName}_`;
  }

  if (lastName) {
    name = `${name}${lastName}_${id}.${ext}`;
  }

  return name;
}

export function capitalize(words: string | null | undefined) {
  return words
    ?.split(' ')
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    ?.join(' ');
}

export const getAccountType = (value: String) => {
  switch (value) {
    case 'individual':
      return 'Individual';
    case 'joint':
      return 'Joint';
    case 'trust':
      return 'Trust';
    default:
      return 'N/A';
  }
}

export function formatMoney(amount: number | string) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'GHS',
  }).format(Number(amount));
}

export function calculateAge(dob: string) {
  var diff_ms = Date.now() - new Date(dob).getTime();
  var age_dt = new Date(diff_ms);
  return Math.abs(age_dt.getUTCFullYear() - 1970);
}

export function formatStringTo2dp(value: string) {
  if (isNaN(Number(value))) {
    return 0.0;
  }
  const valueTo2dp = Number(value.trim().replace(',', '')).toFixed(2);
  return Number(valueTo2dp);
}

export const formatFilenameForS3IDUpload = (
  fileExt: string,
  customer_id: string
) => {
  const date = moment().format('YYYYMMDD');
  const randomString = Math.random().toString(36).substring(2, 7);
  const cleanFileName = customer_id
    .toLocaleLowerCase()
    .replace(/[^a-z0-9]/g, '-');
  const newFilename = `ID-images/${date}-${randomString}-${cleanFileName}`;
  return `${newFilename.substring(0, 60)}.${fileExt}`;
};

export const formatFilenameForAPKUpload = (filename: string) => {
  return `APK-mobile/${filename}`;
};

export const paymentsDump = {
  data: {
    payment: [
      {
        id: 26,
        member: { mf_code: 'PF00000362', __typename: 'member' },
        payment_date: '2020-06-04',
        value_date: '2020-02-19',
        amount: 5000,
        status: { name: 'Pending Approval', __typename: 'status' },
        payment_shares: [
          {
            goal: { id: 1, name: 'Retirement', __typename: 'goal' },
            product: { name: 'Plus Income Fund', __typename: 'product' },
            product_amount: 1000,
            __typename: 'payment_share',
          },
          {
            goal: { id: 1, name: 'Retirement', __typename: 'goal' },
            product: { name: 'Balanced Income Fund', __typename: 'product' },
            product_amount: 4000,
            __typename: 'payment_share',
          },
        ],
        __typename: 'payment',
      },
      {
        id: 25,
        member: { mf_code: 'PF00000362', __typename: 'member' },
        payment_date: '2020-06-04',
        value_date: '2020-02-19',
        amount: 5000,
        status: { name: 'Pending Approval', __typename: 'status' },
        payment_shares: [
          {
            goal: { id: 1, name: 'Retirement', __typename: 'goal' },
            product: { name: 'Plus Income Fund', __typename: 'product' },
            product_amount: 1000,
            __typename: 'payment_share',
          },
          {
            goal: { id: 1, name: 'Retirement', __typename: 'goal' },
            product: { name: 'Balanced Income Fund', __typename: 'product' },
            product_amount: 4000,
            __typename: 'payment_share',
          },
        ],
        __typename: 'payment',
      },
    ],
  },
};

export function getGoalCategories(): any {
  const goalsSet = new Set();
  const dump = paymentsDump.data.payment;
  dump.forEach((dump) => {
    dump.payment_shares.forEach((share) => {
      goalsSet.add(share.goal.name);
    });
  });
  return Array.from(goalsSet);
}

export function flattenRoutes(route: IRoute): IRoute[] {
  if (!route.children) {
    return [route];
  }
  const children: IRoute[] = route.children
    .map((r: IRoute) => {
      if (!r.children) {
        return [r];
      }
      const flat: IRoute[] = flattenRoutes(r);
      return flat;
    })
    .flat();
  return [route, ...children];
}

export function groupBy<T>(list: T[], keyGetter: (item: T) => string) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

export function mapToObj(map: Map<string, any>): Object {
  const obj: { [key: string]: any } = {};
  map.forEach((value, key) => (obj[key] = value));
  return obj;
}

export const customerDump = {
  id: 4,
  user: {
    id: 4,
    first_name: 'Maame Koama',
    last_name: 'Gyasi',
    other_name: 'Nana',
    mobile: '0552123456',
    email: 'asdewrrtrt@gmail.com',
    date_of_birth: '2002-06-01',
    gender: {
      id: 2,
      name: 'Female',
    },
  },
  age: 31,
  signature: 'data:image/png;base64,',
  city: 'Accra',
  psl_code: 'PSL_930024',
  nationality: 'Ghanaian',
  tin: '12356809533u',
  occupation: 'Caterer',
  employer: 'GDS',
  mobile_secondary: null,
  home_address: 'Accra',
  postal_address: 'Accra',
  assigned_to_user: null,
  status: {
    id: 3,
    name: 'Pending Approval',
  },
  industry: {
    id: 13,
    name: 'Bars and Restaurants',
  },
  next_of_kin: {
    id: 1,
    first_name: 'David',
    last_name: 'Daniels',
    other_names: null,
    relationship_id: 5,
    date_of_birth: '2020-06-01',
    mobile: '0244123456',
    email: 'werere@gmail.com',
  },
  member_income_sources: [
    {
      income_source_id: 1,
    },
  ],
  member_contribution_sources: [
    {
      contribution_source_id: 1,
    },
  ],
  beneficiaries: [
    {
      id: 1,
      guid: 'f6f01969-f733-46f7-9f22-5e8fca2f5fe5',
      first_name: 'Meri',
      last_name: 'Adams',
      mobile: '0244898989',
      other_names: '',
      home_address: 'Accra',
      date_of_birth: '2020-06-02',
      allocation: 100,
      relationship_id: 2,
    },
  ],
  member_dependents: [
    {
      id: 6,
      guid: '6b8e8e1f-e853-4fb8-88d0-0d3f1d9510be',
      name: 'Andy',
      age: 10,
    },
    {
      id: 7,
      guid: '2e5d9e9c-2644-42d8-8ecb-10ede7e77753',
      name: 'Abdul ',
      age: 15,
    },
  ],
  member_payment_instructions: [
    {
      id: 1,
      guid: 'd1fa8e10-cd3e-43d8-b570-304008b40652',
      account_name: 'Maame Konama',
      account_number: '1256677837363637',
      branch: 'Osu',
      payment_provider: {
        id: 8,
        name: 'CAL Bank Limited',
        payment_channel_id: 1,
      },
      preferred: true,
      mobile_money_number: null,
    },
  ],
  member_mode_of_instruction_communications: [],
  member_identifications: [
    {
      id: 7,
      identification_type: {
        id: 1,
        name: 'Voters ID',
      },
      identification_number: '123456789',
      identification_card_image_url: 'Maame Koama_4.jpg',
      identification_expiry_date: '2020-07-31',
      identification_issue_date: '2020-06-01',
      country: {
        id: 4,
        name: 'Algeria',
      },
    },
  ],
  member_goals: [
    {
      id: 10,
      guid: '3d69538e-327a-4127-abd9-af30550006a6',
      member_id: 4,
      goal_for: 'Maame Koama',
      accepted: true,
      current_value: 0,
      future_value: 22943.67,
      duration_years: 29,
      duration_months: 1,
      administrative_fees: 0.03,
      goal_id: 5,
      goal: {
        id: 5,
        name: 'Life Insurance',
      },
      monthly_contribution: 1.36,
      expected_return: 19.55,
      has_insurance: false,
    },
    {
      id: 11,
      guid: '567d0359-454e-4666-90b1-e56d8c4207c7',
      member_id: 4,
      goal_for: 'Maame Koama',
      accepted: true,
      current_value: 0,
      future_value: 7642.13,
      duration_years: 1,
      duration_months: 1,
      administrative_fees: 10.96,
      goal_id: 3,
      goal: {
        id: 3,
        name: 'Emergency',
      },
      monthly_contribution: 548.02,
      expected_return: 17.9,
      has_insurance: false,
      goal_insurance: null,
    },
    {
      id: 12,
      guid: '6a5b9ca8-d23e-4e67-acc2-1c57be4ba648',
      member_id: 4,
      goal_for: 'Andy',
      accepted: true,
      current_value: 0,
      future_value: 205419.84,
      duration_years: 5,
      duration_months: 1,
      administrative_fees: 40.68,
      goal_id: 2,
      goal: {
        id: 2,
        name: 'Education',
      },
      monthly_contribution: 2033.97,
      expected_return: 19.53,
      has_insurance: true,
    },
    {
      id: 13,
      guid: '3c5b2f3c-6727-46bb-80b2-f26b5db57e67',
      member_id: 4,
      goal_for: 'Abdul ',
      accepted: true,
      current_value: 0,
      future_value: 101901.72,
      duration_years: 10,
      duration_months: 1,
      administrative_fees: 5.58,
      goal_id: 2,
      goal: {
        id: 2,
        name: 'Education',
      },
      monthly_contribution: 279.23,
      expected_return: 19.55,
      has_insurance: true,
      goal_insurance: null,
    },
    {
      id: 9,
      guid: 'a947ad85-a721-4ea0-8d4e-1bbf898e1da6',
      member_id: 4,
      goal_for: 'Maame Koama',
      accepted: true,
      current_value: 0,
      future_value: 908076.06,
      duration_years: 40,
      duration_months: 0,
      administrative_fees: 0.13,
      goal_id: 1,
      goal: {
        id: 1,
        name: 'Retirement',
      },
      monthly_contribution: 6.46,
      expected_return: 19.55,
      has_insurance: false,
      goal_insurance: null,
    },
  ],
};

export const STEP_VISIBLE_FIELDS_INDIVIDUAL: Record<number, string[]> = {
  0: ['member_goals'],
  1: [
    'user.first_name', 'user.last_name', 'user.other_name', 'user.email',
    'user.date_of_birth', 'user.mobile', 'user.gender_id',
    'title_id', 'marital_status_id', 'place_of_birth', 'nationality',
    'tin', 'city', 'postal_address', 'home_address', 'gps_address'
  ],
  2: [
    'residential_status', 'country_of_origin_id', 'region_id',
    'residential_permit_number', 'permit_issue_date', 'permit_expiry_date',
    'residential_place_of_issue'
  ],
  3: [
    'employment_status', 'industry_id', 'occupation', 'profession', 'employer',
    'employer_address', 'employer_city', 'employer_email', 'employer_contact',
    'nature_of_business', 'years_of_employment', 'years_of_current_employment',
    'years_of_previous_employment', 'professional_license_number'
  ],
  4: ['member_income_sources', 'member_contribution_sources'],
  5: [
    'initial_investment_amount', 'regular_top_up_amount', 'regular_withdrawal_amount',
    'anticipated_investment_activity_top_ups', 'anticipated_investment_activity_withdrawals'
  ],
  6: ['client_investment_profile'],
  7: ['account_mandate'],
  8: ['mode_of_statement_delivery', 'statement_frequency'],
  9: ['next_of_kin'],
  10: ['beneficiaries'],
  11: ['member_dependents'],
  12: ['member_payment_instructions'],
  13: ['member_mode_of_instruction_communications'],
  14: ['member_identifications', 'signature', 'kyc_form', 'id_file'],
};

export const STEP_VISIBLE_FIELDS_TRUST: Record<number, string[]> = {
  0: ['member_goals'],
  1: [
    'user.first_name',
    'user.last_name',
    'user.other_name',
    'user.email',
    'user.date_of_birth',
    'user.mobile',
    'user.gender_id',
    'title_id',
    'marital_status_id',
    'place_of_birth',
    'nationality',
    'tin',
    'city',
    'postal_address',
    'home_address',
    'gps_address',
  ],
  2: [
    'residential_status',
    'country_of_origin_id',
    'country_of_residence_id',
    'region_id',
    'residential_permit_number',
    'permit_issue_date',
    'permit_expiry_date',
    'residential_place_of_issue',
  ],
  3: [
    'employment_status',
    'industry_id',
    'occupation',
    'profession',
    'employer',
    'employer_address',
    'employer_city',
    'employer_email',
    'employer_contact',
    'nature_of_business',
    'years_of_employment',
    'years_of_current_employment',
    'years_of_previous_employment',
    'professional_license_number',
  ],
  4: ['member_income_sources', 'member_contribution_sources'],
  5: [
    'initial_investment_amount',
    'regular_top_up_amount',
    'regular_withdrawal_amount',
    'anticipated_investment_activity_top_ups',
    'anticipated_investment_activity_top_ups_other',
    'anticipated_investment_activity_withdrawals',
    'anticipated_investment_activity_withdrawals_other'
  ],
  6: ['client_investment_profile'],
  7: ['account_mandate'],
  8: ['mode_of_statement_delivery', 'statement_frequency'],
  9: [
    'user.first_name_jt',
    'user.last_name_jt',
    'user.other_name_jt',
    'user.email_jt',
    'user.date_of_birth_jt',
    'user.mobile_jt',
    'user.gender_id_jt',
    'title_id_jt',
    'marital_status_id_jt',
    'place_of_birth_jt',
    'tin_jt',
    'home_address_jt',
    'gps_address_jt',
    'relationship_jt',
    'residential_status_jt',
    'country_of_origin_id_jt',
    'country_of_residence_id_jt',
    'id_type_jt',
    'id_number_jt',
    'id_issue_date_jt',
  ],
  10: ['beneficiaries'],
  11: ['member_dependents'],
  12: ['member_payment_instructions'],
  13: ['member_mode_of_instruction_communications'],
  14: [
    'member_identifications',
    'signature',
    'kyc_form',
  ],
};

export const STEP_VISIBLE_FIELDS_JOINT_PROSPECT: Record<number, string[]> = {
  0: ['member_goals'],
  1: [
    'user.first_name', 'user.last_name', 'user.other_name', 'user.email',
    'user.date_of_birth', 'user.mobile', 'user.gender_id',
    'user.first_name_jt', 'user.last_name_jt', 'user.other_name_jt',
    'user.email_jt', 'user.date_of_birth_jt', 'user.mobile_jt',
    'user.mobile_jt2', 'user.gender_id_jt', "relationship_jt",
    'title_id', 'title_id_jt', 'marital_status_id', 'marital_status_id_jt',
    'place_of_birth', 'place_of_birth_jt', 'nationality',
    'tin', 'tin_jt', 'city', 'postal_address',
    'home_address', 'home_address_jt', 'gps_address', 'gps_address_jt',
    'id_type_jt', 'id_number_jt',
    'id_issue_date_jt', 'id_expiry_date_jt', 'place_of_issue_jt'
  ],
  2: [
    'residential_status', 'country_of_origin_id', 'region_id',
    'residential_status_jt', 'country_of_origin_id_jt', 'region_id_jt',
  ],
  3: [
    'employment_status', 'industry_id', 'occupation', 'profession',
    'employer', 'employer_address', 'employer_city', 'employer_email',
    'employer_contact', 'nature_of_business', 'years_of_employment',
    'years_of_current_employment', 'years_of_previous_employment',
    'professional_license_number',
    'employment_status_jt', 'occupation_jt', 'profession_jt',
    'employer_jt', 'employer_address_jt', 'employer_city_jt',
    'employer_email_jt', 'employer_contact_jt', 'nature_of_business_jt',
    'years_of_employment_jt', 'years_of_current_employment_jt',
    'years_of_previous_employment_jt', 'professional_license_number_jt'
  ],
  4: ['member_income_sources', 'member_contribution_sources'],
  5: [
    'initial_investment_amount', 'regular_top_up_amount', 'regular_withdrawal_amount',
    'anticipated_investment_activity_top_ups', 'anticipated_investment_activity_withdrawals'
  ],
  6: ['client_investment_profile'],
  7: ['account_mandate'],
  8: ['mode_of_statement_delivery', 'statement_frequency'],
  9: ['next_of_kin'],
  10: ['beneficiaries'],
  11: ['member_dependents'],
  12: ['member_payment_instructions'],
  13: ['member_mode_of_instruction_communications'],
  14: ['member_identifications', 'signature', 'kyc_form', 'id_file'],
};


/**
 * Get the appropriate step visible fields based on prospect type
 */
export const getStepVisibleFields = (accountType: string): Record<number, string[]> => {
  switch (accountType) {
    case 'individual':
      return STEP_VISIBLE_FIELDS_INDIVIDUAL;
    case 'trust_joint':
      return STEP_VISIBLE_FIELDS_JOINT_PROSPECT;
    default:
      return STEP_VISIBLE_FIELDS_INDIVIDUAL;
  }
};

// Create a partial schema that only validates specific fields
const createPartialSchema = (schema: Yup.ObjectSchema<any>, fields: string[]) => {
  const shape: any = {};

  fields.forEach(field => {
    const fieldSchema = schema.fields[field];
    if (fieldSchema) {
      shape[field] = fieldSchema;
    }
  });

  return Yup.object().shape(shape);
};

// Validate only the current step
export const validateCurrentStep = async (
  stepIndex: number,
  values: any,
  fullSchema: Yup.ObjectSchema<any>,
  setTouched: (touched: any) => void,
  prospectType: string = 'individual'
): Promise<boolean> => {
  const stepVisibleFields = getStepVisibleFields(prospectType);
  const visibleFields = stepVisibleFields[stepIndex] || [];

  console.log('=== VALIDATION DEBUG ===');
  console.log('Prospect Type:', prospectType);
  console.log('Current Step:', stepIndex);
  console.log('Visible Fields:', visibleFields);
  console.log('Current Values:', values);

  if (visibleFields.length === 0) {
    console.log('No fields to validate for this step');
    return true;
  }

  try {
    const partialSchema = createPartialSchema(fullSchema, visibleFields);

    console.log('Partial Schema Fields:', Object.keys(partialSchema.fields ?? {}));

    const valuesToValidate: any = {};
    visibleFields.forEach(field => {
      valuesToValidate[field] = values[field];
    });
    console.log('Values being validated:', valuesToValidate);

    await partialSchema.validate(values, {
      abortEarly: false,
      context: { beneficiaries: values.beneficiaries }
    });

    console.log('✅ Validation passed for step', stepIndex);
    return true;
  } catch (err) {
    if (err instanceof Yup.ValidationError) {
      console.log('❌ Validation failed for step', stepIndex);
      console.log('Validation Errors:', err.errors);
      console.log('Error Details:', err.inner.map(e => ({
        path: e.path,
        message: e.message,
        value: e.value,
        type: e.type
      })));

      const touched: any = {};
      err.inner.forEach(error => {
        if (error.path) {
          console.log(`Field error: ${error.path} - ${error.message}`);

          const parts = error.path.split('.');
          let current = touched;

          parts.forEach((part, index) => {
            const arrayMatch = part.match(/^(\w+)\[(\d+)\]$/);
            if (arrayMatch) {
              const [, arrayName, idx] = arrayMatch;
              if (!current[arrayName]) current[arrayName] = [];
              if (!current[arrayName][parseInt(idx)]) {
                current[arrayName][parseInt(idx)] = {};
              }
              current = current[arrayName][parseInt(idx)];
            } else if (index === parts.length - 1) {
              current[part] = true;
            } else {
              if (!current[part]) current[part] = {};
              current = current[part];
            }
          });
        }
      });

      console.log('Touched fields:', touched);
      setTouched(touched);
      return false;
    }

    console.error('Unexpected validation error:', err);
    return false;
  }
};

// Next button handler
export const handleNextStep = async (
  currentStep: number,
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>,
  values: any,
  fullSchema: Yup.ObjectSchema<any>,
  setTouched: (touched: any) => void,
  maxSteps: number,
  prospectType: string = 'individual'
) => {
  console.log('\n🔄 handleNextStep called');
  console.log('Prospect Type:', prospectType);
  console.log('Current step:', currentStep);
  console.log('Max steps:', maxSteps);

  const isValid = await validateCurrentStep(
    currentStep,
    values,
    fullSchema,
    setTouched,
    prospectType
  );

  console.log('Step validation result:', isValid);

  if (isValid) {
    const nextStep = Math.min(currentStep + 1, maxSteps - 1);
    console.log('✅ Moving to next step:', nextStep);
    setCurrentStep(nextStep);
  } else {
    console.log('❌ Cannot proceed - validation failed');
  }

  console.log('=== END VALIDATION ===\n');
};

// Save button handler - validates entire form

export const handleSaveCustomer = async (
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>,
  setSaveDialogIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
  values: any,
  fullSchema: Yup.ObjectSchema<any>,
  validateForm: () => Promise<any>,
  setTouched: (touched: any) => void,
  notify: (success: boolean, message: string) => void,
  prospectType: string = "individual"
) => {
  console.log("\n💾 handleSaveCustomer called");
  console.log("Prospect Type:", prospectType);

  // ✅ Check next of kin or beneficiaries
  const hasNextOfKin =
    (values?.next_of_kin?.first_name || values?.first_name_jt) &&
    (values?.next_of_kin?.first_name || values?.first_name_jt) !== "." &&
    (values?.next_of_kin?.first_name || values?.first_name_jt) !== "";

  const hasBeneficiaries = values?.beneficiaries?.length > 0;

  console.log("Full values:", values);
  console.log("hasNextOfKin:", hasNextOfKin);
  console.log("hasBeneficiaries:", hasBeneficiaries);

  if (!hasNextOfKin && !hasBeneficiaries) {
    console.log("❌ Next of kin or beneficiaries required");
    notify(false, "Please provide either Next of Kin or Beneficiary information");
    setCurrentStep(10);
    setTouched({ next_of_kin: { first_name: true } });
    return;
  }

  // ✅ Validate entire form
  console.log("🔍 Validating entire form...");
  const errors = await validateForm();
  console.log("Validation errors:", errors);
  console.log("Error count:", Object.keys(errors).length);

  if (Object.keys(errors).length === 0) {
    console.log("✅ All validations passed - opening save dialog");
    setSaveDialogIsOpen(true);
  } else {
    console.log("❌ Validation failed");
    console.log("Detailed errors:", JSON.stringify(errors, null, 2));

    notify(false, "Please complete all required fields before saving");

    // ✅ Find first step with errors — supports nested keys
    const stepVisibleFields = getStepVisibleFields(prospectType);
    let firstErrorStep = -1;

    for (const [step, fields] of Object.entries(stepVisibleFields)) {
      const stepNum = parseInt(step);
      const hasError = fields.some((field) => {
        // Use lodash.get to support nested error paths
        return get(errors, field) !== undefined;
      });

      if (hasError) {
        firstErrorStep = stepNum;
        console.log(
          `First error found in step ${stepNum}:`,
          fields
            .filter((f) => get(errors, f))
            .map((f) => ({ field: f, error: get(errors, f) }))
        );
        break;
      }
    }

    if (firstErrorStep !== -1) {
      console.log("Navigating to first error step:", firstErrorStep);
      setCurrentStep(firstErrorStep);
    }

    // ✅ Mark all error fields as touched (supports nested)
    const markTouched = (errObj: any): any => {
      const touched: any = {};
      for (const key in errObj) {
        if (typeof errObj[key] === "object" && errObj[key] !== null) {
          touched[key] = markTouched(errObj[key]);
        } else {
          touched[key] = true;
        }
      }
      return touched;
    };

    const allTouched = markTouched(errors);
    setTouched(allTouched);
  }

  console.log("=== END SAVE VALIDATION ===\n");
};

export const getInitialValues = (member?: Member): any => {
  return {
    // User fields
    user: {
      id: member?.user?.id ?? undefined,
      first_name: member?.user?.first_name ?? '',
      last_name: member?.user?.last_name ?? '',
      other_name: member?.user?.other_name ?? '',
      email: member?.user?.email ?? '',
      date_of_birth: member?.user?.date_of_birth ?? null,
      mobile: member?.user?.mobile ?? '',
      gender_id: member?.user?.gender_id ?? undefined,
    },

    // Member basic info
    id: member?.id ?? undefined,
    title_id: member?.title_id ?? undefined,
    marital_status_id: member?.marital_status_id ?? null,
    place_of_birth: member?.place_of_birth ?? '',
    nationality: member?.nationality ?? '',
    tin: member?.tin ?? '',
    city: member?.city ?? '',
    postal_address: member?.postal_address ?? '',
    home_address: member?.home_address ?? '',
    gps_address: member?.gps_address ?? '',
    age: member?.age ?? null,
    mf_code: member?.mf_code ?? '',
    psl_code: member?.psl_code ?? '',

    // Residential info
    residential_status: member?.residential_status ?? '',
    country_of_origin_id: member?.country_of_origin_id ?? null,
    region_id: member?.region_id ?? null,
    residential_permit_number: member?.residential_permit_number ?? '',
    permit_issue_date: member?.permit_issue_date ?? null,
    permit_expiry_date: member?.permit_expiry_date ?? null,
    residential_place_of_issue: member?.residential_place_of_issue ?? '',

    // Employment info
    employment_status: member?.employment_status ?? '',
    industry_id: member?.industry_id ?? null,
    occupation: member?.occupation ?? '',
    profession: member?.profession ?? '',
    employer: member?.employer ?? '',
    employer_address: member?.employer_address ?? '',
    employer_city: member?.employer_city ?? '',
    employer_email: member?.employer_email ?? '',
    employer_contact: member?.employer_contact ?? '',
    nature_of_business: member?.nature_of_business ?? '',
    years_of_employment: member?.years_of_employment ?? null,
    years_of_current_employment: member?.years_of_current_employment ?? null,
    years_of_previous_employment: member?.years_of_previous_employment ?? null,
    professional_license_number: member?.professional_license_number ?? '',

    // Investment info
    initial_investment_amount: member?.initial_investment_amount ?? undefined,
    regular_top_up_amount: member?.regular_top_up_amount ?? undefined,
    regular_withdrawal_amount: member?.regular_withdrawal_amount ?? undefined,
    anticipated_investment_activity_top_ups: member?.anticipated_investment_activity_top_ups ?? '',
    anticipated_investment_activity_top_ups_other: member?.anticipated_investment_activity_top_ups_other ?? '',
    anticipated_investment_activity_withdrawals: member?.anticipated_investment_activity_withdrawals ?? '',
    anticipated_investment_activity_withdrawals_other: member?.anticipated_investment_activity_withdrawals_other ?? '',

    // Client investment profile
    client_investment_profile: {
      id: member?.client_investment_profile?.id ?? undefined,
      investment_objective: member?.client_investment_profile?.investment_objective ?? '',
      investment_knowledge: member?.client_investment_profile?.investment_knowledge ?? '',
      risk_tolerance: member?.client_investment_profile?.risk_tolerance ?? '',
      investment_horizon: member?.client_investment_profile?.investment_horizon ?? '',
      approximate_annual_income: member?.client_investment_profile?.approximate_annual_income ?? '',
    },

    // Account settings
    account_mandate: member?.account_mandate ?? '',
    mode_of_statement_delivery: member?.mode_of_statement_delivery ?? '',
    statement_frequency: member?.statement_frequency ?? '',

    // Next of kin
    next_of_kin: {
      id: member?.next_of_kin?.id ?? undefined,
      title: member?.next_of_kin?.title ?? '',
      first_name: member?.next_of_kin?.first_name ?? '',
      last_name: member?.next_of_kin?.last_name ?? '',
      other_names: member?.next_of_kin?.other_names ?? '',
      email: member?.next_of_kin?.email ?? '',
      mobile: member?.next_of_kin?.mobile ?? null,
      mobile2: member?.next_of_kin?.mobile2 ?? '',
      date_of_birth: member?.next_of_kin?.date_of_birth ?? null,
      gender_id: member?.next_of_kin?.gender_id ?? null,
      place_of_birth: member?.next_of_kin?.place_of_birth ?? '',
      marital_status: member?.next_of_kin?.marital_status ?? '',
      relationship_id: member?.next_of_kin?.relationship_id ?? null,
      home_address: member?.next_of_kin?.home_address ?? '',
      gps_address: member?.next_of_kin?.gps_address ?? '',
      occupation: member?.next_of_kin?.occupation ?? '',
      profession: member?.next_of_kin?.profession ?? '',
      professional_license: member?.next_of_kin?.professional_license ?? '',
      tin: member?.next_of_kin?.tin ?? '',
      residential_status: member?.next_of_kin?.residential_status ?? '',
      country_of_origin_id: member?.next_of_kin?.country_of_origin_id ?? null,
      region_id: member?.next_of_kin?.region_id ?? null,
      residential_permit_number: member?.next_of_kin?.residential_permit_number ?? '',
      permit_issue_date: member?.next_of_kin?.permit_issue_date ?? null,
      permit_expiry_date: member?.next_of_kin?.permit_expiry_date ?? null,
      residential_place_of_issue: member?.next_of_kin?.residential_place_of_issue ?? '',
      id_type: member?.next_of_kin?.id_type ?? '',
      id_number: member?.next_of_kin?.id_number ?? '',
      id_issue_date: member?.next_of_kin?.id_issue_date ?? null,
      id_expiry_date: member?.next_of_kin?.id_expiry_date ?? null,
    },

    // Beneficiaries
    beneficiaries: member?.beneficiaries?.map(b => ({
      id: b.id ?? undefined,
      guid: b.guid ?? undefined,
      first_name: b.first_name ?? '',
      last_name: b.last_name ?? '',
      other_names: b.other_names ?? '',
      email: b.email ?? '',
      mobile: b.mobile ?? '',
      mobile2: b.mobile2 ?? '',
      date_of_birth: b.date_of_birth ?? undefined,
      gender_id: b.gender_id ?? '',
      place_of_birth: b.place_of_birth ?? '',
      marital_status: b.marital_status ?? '',
      relationship_id: b.relationship_id ?? null,
      allocation: b.allocation ?? 0,
      home_address: b.home_address ?? '',
      gps_address: b.gps_address ?? '',
      occupation: b.occupation ?? '',
      profession: b.profession ?? '',
      professional_license: b.professional_license ?? '',
      tin: b.tin ?? null,
      title: b.title ?? '',
      residential_status: b.residential_status ?? '',
      country_of_origin_id: b.country_of_origin_id ?? null,
      region_id: b.region_id ?? null,
      residential_permit_number: b.residential_permit_number ?? '',
      permit_issue_date: b.permit_issue_date ?? null,
      permit_expiry_date: b.permit_expiry_date ?? null,
      residential_place_of_issue: b.residential_place_of_issue ?? '',
      id_type: b.id_type ?? '',
      id_number: b.id_number ?? '',
      id_issue_date: b.id_issue_date ?? null,
      id_expiry_date: b.id_expiry_date ?? null,
    })) ?? [],

    // Member dependents
    member_dependents: member?.member_dependents?.map(d => ({
      id: d.id ?? undefined,
      guid: d.guid ?? undefined,
      name: d.name ?? '',
      age: d.age ?? null,
    })) ?? [],

    // Member goals
    member_goals: member?.member_goals?.map(g => ({
      id: g.id ?? undefined,
      guid: g.guid ?? undefined,
      goal_id: g.goal_id ?? null,
      goal_for: g.goal_for ?? '',
      duration_months: g.duration_months ?? 0,
      duration_years: g.duration_years ?? 0,
      expected_return: g.expected_return ?? 0,
      monthly_contribution: g.monthly_contribution ?? 0,
      future_value: g.future_value ?? 0,
      current_value: g.current_value ?? 0,
      administrative_fees: g.administrative_fees ?? 0,
      years_to_fund: g.years_to_fund ?? 0,
      has_insurance: g.has_insurance ?? false,
      accepted: g.accepted ?? false,
      goal_insurances: g.goal_insurances ?? [],
    })) ?? [],

    // Member identifications
    member_identifications: member?.member_identifications?.map(i => ({
      id: i.id ?? undefined,
      identification_type: {
        id: i.identification_type?.id ?? ''
      },
      identification_number: i.identification_number ?? '',
      country: {
        id: i.country?.id ?? '',
      },
      place_of_issue: i.place_of_issue ?? '',
      identification_issue_date: i.identification_issue_date ?? null,
      identification_expiry_date: i.identification_expiry_date ?? null,
      identification_card_image_url: i.identification_card_image_url ?? '',
    })) ?? [{
      identification_type: { id: '' },
      identification_number: '',
      country: { id: '' },
      place_of_issue: '',
      identification_issue_date: null,
      identification_expiry_date: null,
      identification_card_image_url: '',
    }],

    // Payment instructions
    member_payment_instructions: member?.member_payment_instructions?.map(p => ({
      id: p.id ?? undefined,
      guid: p.guid ?? undefined,
      payment_provider: {
        id: p.payment_provider?.id ?? null,
        payment_channel_id: p.payment_provider?.payment_channel_id ?? null,
      },
      account_name: p.account_name ?? '',
      account_number: p.account_number ?? '',
      branch_id: p.branch_id ?? null,
      mobile_money_number: p.mobile_money_number ?? '',
      preferred: p.preferred ?? false,
    })) ?? [{
      payment_provider: { id: null, payment_channel_id: null },
      account_name: '',
      account_number: '',
      branch_id: null,
      mobile_money_number: '',
      preferred: false,
    }],

    // Income sources
    member_income_sources: member?.member_income_sources?.map(i => ({
      income_source: {
        id: i.income_source?.id ?? null,
        name: i.income_source?.name ?? '',
      },
    })) ?? [],

    // Contribution sources
    member_contribution_sources: member?.member_contribution_sources?.map(c => ({
      contribution_source: {
        id: c.contribution_source?.id ?? null,
        name: c.contribution_source?.name ?? '',
      },
    })) ?? [],

    // Mode of instruction communications
    member_mode_of_instruction_communications: member?.member_mode_of_instruction_communications?.map(m => ({
      mode_of_instruction_communication_id: m.mode_of_instruction_communication_id ?? null,
    })) ?? [],

    // Documents
    signature: member?.signature ?? '',
    kyc_form: member?.kyc_form ?? '',
    id_file: undefined,
  };
};

export const normalizeId = (value?: string | number | null) =>
  value && value !== '' ? Number(value) : null;

export const normalizeDate = (value?: string | Date | null) =>
  value ? new Date(value).toISOString() : null;

export const getProspectInitialValues = (member?: Member): any => {
  return {
    // User fields (Primary)
    user: {
      id: member?.user?.id ?? undefined,
      first_name: member?.user?.first_name ?? '',
      last_name: member?.user?.last_name ?? '',
      other_name: member?.user?.other_name ?? '',
      email: member?.user?.email ?? '',
      date_of_birth: member?.user?.date_of_birth ?? null,
      mobile: member?.user?.mobile ?? '',
      gender_id: member?.user?.gender_id ?? undefined,

      // Joint/Trust holder fields
      first_name_jt: member?.user?.first_name_jt ?? '',
      last_name_jt: member?.user?.last_name_jt ?? '',
      other_name_jt: member?.user?.other_name_jt ?? '',
      email_jt: member?.user?.email_jt ?? '',
      date_of_birth_jt: member?.user?.date_of_birth_jt ?? null,
      mobile_jt: member?.user?.mobile_jt ?? '',
      mobile_jt2: member?.user?.mobile_jt2 ?? '',
      gender_id_jt: member?.user?.gender_id_jt ?? undefined,
    },

    // Member basic info
    id: member?.id ?? undefined,
    title_id: member?.title_id ?? undefined,
    title_id_jt: member?.title_id_jt ?? undefined,
    marital_status_id: member?.marital_status_id ?? null,
    marital_status_id_jt: member?.marital_status_id_jt ?? null,
    place_of_birth: member?.place_of_birth ?? '',
    place_of_birth_jt: member?.place_of_birth_jt ?? '',
    nationality: member?.nationality ?? '',
    tin: member?.tin ?? '',
    tin_jt: member?.tin_jt ?? '',
    city: member?.city ?? '',
    postal_address: member?.postal_address ?? '',
    home_address: member?.home_address ?? '',
    home_address_jt: member?.home_address_jt ?? '',
    gps_address: member?.gps_address ?? '',
    gps_address_jt: member?.gps_address_jt ?? '',
    age: member?.age ?? null,
    mf_code: member?.mf_code ?? '',
    psl_code: member?.psl_code ?? '',

    // Joint/Trust relationship info
    relationship_jt: member?.relationship_jt ?? '',
    id_type_jt: member?.id_type_jt ?? '',
    id_number_jt: member?.id_number_jt ?? '',
    id_issue_date_jt: member?.id_issue_date_jt ?? null,
    id_expiry_date_jt: member?.id_expiry_date_jt ?? null,
    place_of_issue_jt: member?.place_of_issue_jt ?? '',

    // Residential info (Primary)
    residential_status: member?.residential_status ?? '',
    country_of_origin_id: member?.country_of_origin_id ?? null,
    country_of_residence_id: member?.country_of_residence_id ?? null,
    region_id: member?.region_id ?? null,
    residential_permit_number: member?.residential_permit_number ?? '',
    permit_issue_date: member?.permit_issue_date ?? null,
    permit_expiry_date: member?.permit_expiry_date ?? null,
    residential_place_of_issue: member?.residential_place_of_issue ?? '',

    // Residential info (Joint/Trust)
    residential_status_jt: member?.residential_status_jt ?? '',
    country_of_origin_id_jt: member?.country_of_origin_id_jt ?? null,
    country_of_residence_id_jt: member?.country_of_residence_id_jt ?? null,
    residential_permit_number_jt: member?.residential_permit_number_jt ?? '',
    permit_issue_date_jt: member?.permit_issue_date_jt ?? null,
    permit_expiry_date_jt: member?.permit_expiry_date_jt ?? null,
    residential_place_of_issue_jt: member?.residential_place_of_issue_jt ?? '',

    // Employment info (Primary)
    employment_status: member?.employment_status ?? '',
    industry_id: member?.industry_id ?? null,
    occupation: member?.occupation ?? '',
    profession: member?.profession ?? '',
    employer: member?.employer ?? '',
    employer_address: member?.employer_address ?? '',
    employer_city: member?.employer_city ?? '',
    employer_email: member?.employer_email ?? '',
    employer_contact: member?.employer_contact ?? '',
    nature_of_business: member?.nature_of_business ?? '',
    years_of_employment: member?.years_of_employment ?? null,
    years_of_current_employment: member?.years_of_current_employment ?? null,
    years_of_previous_employment: member?.years_of_previous_employment ?? null,
    professional_license_number: member?.professional_license_number ?? '',

    // Employment info (Joint/Trust)
    employment_status_jt: member?.employment_status_jt ?? '',
    occupation_jt: member?.occupation_jt ?? '',
    profession_jt: member?.profession_jt ?? '',
    employer_jt: member?.employer_jt ?? '',
    employer_address_jt: member?.employer_address_jt ?? '',
    employer_city_jt: member?.employer_city_jt ?? '',
    employer_email_jt: member?.employer_email_jt ?? '',
    employer_contact_jt: member?.employer_contact_jt ?? '',
    nature_of_business_jt: member?.nature_of_business_jt ?? '',
    years_of_employment_jt: member?.years_of_employment_jt ?? null,
    years_of_current_employment_jt: member?.years_of_current_employment_jt ?? null,
    years_of_previous_employment_jt: member?.years_of_previous_employment_jt ?? null,
    professional_license_number_jt: member?.professional_license_number_jt ?? '',

    // Investment info
    initial_investment_amount: member?.initial_investment_amount ?? undefined,
    regular_top_up_amount: member?.regular_top_up_amount ?? undefined,
    regular_withdrawal_amount: member?.regular_withdrawal_amount ?? undefined,
    anticipated_investment_activity_top_ups: member?.anticipated_investment_activity_top_ups ?? '',
    anticipated_investment_activity_top_ups_other: member?.anticipated_investment_activity_top_ups_other ?? '',
    anticipated_investment_activity_withdrawals: member?.anticipated_investment_activity_withdrawals ?? '',
    anticipated_investment_activity_withdrawals_other: member?.anticipated_investment_activity_withdrawals_other ?? '',

    // Client investment profile
    client_investment_profile: {
      id: member?.client_investment_profile?.id ?? undefined,
      investment_objective: member?.client_investment_profile?.investment_objective ?? '',
      investment_knowledge: member?.client_investment_profile?.investment_knowledge ?? '',
      risk_tolerance: member?.client_investment_profile?.risk_tolerance ?? '',
      investment_horizon: member?.client_investment_profile?.investment_horizon ?? '',
      approximate_annual_income: member?.client_investment_profile?.approximate_annual_income ?? '',
    },

    // Account settings
    account_mandate: member?.account_mandate ?? '',
    mode_of_statement_delivery: member?.mode_of_statement_delivery ?? '',
    statement_frequency: member?.statement_frequency ?? '',

    // Next of kin
    next_of_kin: {
      id: member?.next_of_kin?.id ?? undefined,
      title: member?.next_of_kin?.title ?? '',
      first_name: member?.next_of_kin?.first_name ?? '',
      last_name: member?.next_of_kin?.last_name ?? '',
      other_names: member?.next_of_kin?.other_names ?? '',
      email: member?.next_of_kin?.email ?? '',
      mobile: member?.next_of_kin?.mobile ?? null,
      mobile2: member?.next_of_kin?.mobile2 ?? '',
      date_of_birth: member?.next_of_kin?.date_of_birth ?? null,
      gender_id: member?.next_of_kin?.gender_id ?? null,
      place_of_birth: member?.next_of_kin?.place_of_birth ?? '',
      marital_status: member?.next_of_kin?.marital_status ?? '',
      relationship_id: member?.next_of_kin?.relationship_id ?? null,
      home_address: member?.next_of_kin?.home_address ?? '',
      gps_address: member?.next_of_kin?.gps_address ?? '',
      occupation: member?.next_of_kin?.occupation ?? '',
      profession: member?.next_of_kin?.profession ?? '',
      professional_license: member?.next_of_kin?.professional_license ?? '',
      tin: member?.next_of_kin?.tin ?? '',
      residential_status: member?.next_of_kin?.residential_status ?? '',
      country_of_origin_id: member?.next_of_kin?.country_of_origin_id ?? null,
      region_id: member?.next_of_kin?.region_id ?? null,
      residential_permit_number: member?.next_of_kin?.residential_permit_number ?? '',
      permit_issue_date: member?.next_of_kin?.permit_issue_date ?? null,
      permit_expiry_date: member?.next_of_kin?.permit_expiry_date ?? null,
      residential_place_of_issue: member?.next_of_kin?.residential_place_of_issue ?? '',
      id_type: member?.next_of_kin?.id_type ?? '',
      id_number: member?.next_of_kin?.id_number ?? '',
      id_issue_date: member?.next_of_kin?.id_issue_date ?? null,
      id_expiry_date: member?.next_of_kin?.id_expiry_date ?? null,
    },

    // Beneficiaries
    beneficiaries: member?.beneficiaries?.map(b => ({
      id: b.id ?? undefined,
      guid: b.guid ?? undefined,
      first_name: b.first_name ?? '',
      last_name: b.last_name ?? '',
      other_names: b.other_names ?? '',
      email: b.email ?? '',
      mobile: b.mobile ?? '',
      mobile2: b.mobile2 ?? '',
      date_of_birth: b.date_of_birth ?? null,
      gender_id: b.gender_id ?? null,
      place_of_birth: b.place_of_birth ?? '',
      marital_status: b.marital_status ?? '',
      relationship_id: b.relationship_id ?? null,
      allocation: b.allocation ?? 0,
      home_address: b.home_address ?? '',
      gps_address: b.gps_address ?? '',
      occupation: b.occupation ?? '',
      profession: b.profession ?? '',
      professional_license: b.professional_license ?? '',
      tin: b.tin ?? null,
      title: b.title ?? '',
      residential_status: b.residential_status ?? '',
      country_of_origin_id: b.country_of_origin_id ?? null,
      region_id: b.region_id ?? null,
      residential_permit_number: b.residential_permit_number ?? '',
      permit_issue_date: b.permit_issue_date ?? null,
      permit_expiry_date: b.permit_expiry_date ?? null,
      residential_place_of_issue: b.residential_place_of_issue ?? '',
      id_type: b.id_type ?? '',
      id_number: b.id_number ?? '',
      id_issue_date: b.id_issue_date ?? null,
      id_expiry_date: b.id_expiry_date ?? null,
    })) ?? [],

    // Member dependents
    member_dependents: member?.member_dependents?.map(d => ({
      id: d.id ?? undefined,
      guid: d.guid ?? undefined,
      name: d.name ?? '',
      age: d.age ?? null,
    })) ?? [],

    // Member goals
    member_goals: member?.member_goals?.map(g => ({
      id: g.id ?? undefined,
      guid: g.guid ?? undefined,
      goal_id: g.goal_id ?? null,
      goal_for: g.goal_for ?? '',
      duration_months: g.duration_months ?? 0,
      duration_years: g.duration_years ?? 0,
      expected_return: g.expected_return ?? 0,
      monthly_contribution: g.monthly_contribution ?? 0,
      future_value: g.future_value ?? 0,
      current_value: g.current_value ?? 0,
      administrative_fees: g.administrative_fees ?? 0,
      years_to_fund: g.years_to_fund ?? 0,
      has_insurance: g.has_insurance ?? false,
      accepted: g.accepted ?? false,
      accepted_on: g.accepted_on ?? null,
      goal_insurances: g.goal_insurances ?? [],
    })) ?? [],

    // Member identifications
    member_identifications: member?.member_identifications?.map(i => ({
      id: i.id ?? undefined,
      identification_type: {
        id: i.identification_type?.id ?? '',
      },
      identification_number: i.identification_number ?? '',
      country: {
        id: i.country?.id ?? '',
      },
      place_of_issue: i.place_of_issue ?? '',
      identification_issue_date: i.identification_issue_date ?? null,
      identification_expiry_date: i.identification_expiry_date ?? null,
      identification_card_image_url: i.identification_card_image_url ?? '',
    })) ?? [{
      identification_type: { id: '' },
      identification_number: '',
      country: { id: '' },
      place_of_issue: '',
      identification_issue_date: null,
      identification_expiry_date: null,
      identification_card_image_url: '',
    }],

    // Payment instructions
    member_payment_instructions: member?.member_payment_instructions?.map(p => ({
      id: p.id ?? undefined,
      guid: p.guid ?? undefined,
      payment_provider: {
        id: p.payment_provider?.id ?? null,
        payment_channel_id: p.payment_provider?.payment_channel_id ?? null,
      },
      account_name: p.account_name ?? '',
      account_number: p.account_number ?? '',
      branch_id: p.branch_id ?? null,
      mobile_money_number: p.mobile_money_number ?? '',
      preferred: p.preferred ?? false,
    })) ?? [{
      payment_provider: { id: null, payment_channel_id: null },
      account_name: '',
      account_number: '',
      branch_id: null,
      mobile_money_number: '',
      preferred: false,
    }],

    // Income sources
    member_income_sources: member?.member_income_sources?.map(i => ({
      income_source: {
        id: i.income_source?.id ?? null,
        name: i.income_source?.name ?? '',
      },
    })) ?? [],

    // Contribution sources
    member_contribution_sources: member?.member_contribution_sources?.map(c => ({
      contribution_source: {
        id: c.contribution_source?.id ?? null,
        name: c.contribution_source?.name ?? '',
      },
    })) ?? [],

    // Mode of instruction communications
    member_mode_of_instruction_communications: member?.member_mode_of_instruction_communications?.map(m => ({
      mode_of_instruction_communication_id: m.mode_of_instruction_communication_id ?? null,
    })) ?? [],

    // Documents
    signature: member?.signature ?? '',
    kyc_form: member?.kyc_form ?? '',
    id_file: undefined,
  };
};

export const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === '.' || e.key === '-' || e.key === 'e' || e.key === 'E') {
    e.preventDefault();
  }
};

export const formatValidationErrors = (errors: any): string => {
  if (!errors || Object.keys(errors).length === 0) {
    return 'Please fill in all required fields';
  }
  
  const errorMessages: string[] = [];
  
  Object.entries(errors).forEach(([field, value]) => {
    const formattedField = field
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
    
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item === 'object' && item !== null) {
          Object.entries(item).forEach(([subField, subMessage]) => {
            const formattedSubField = subField.replace(/_/g, ' ');
            errorMessages.push(`${formattedField} ${index + 1} - ${formattedSubField}: ${subMessage}`);
          });
        }
      });
    } else if (typeof value === 'object' && value !== null) {
      Object.entries(value).forEach(([subField, subMessage]) => {
        const formattedSubField = subField
          .replace(/_/g, ' ')
          .replace(/\b\w/g, char => char.toUpperCase());
        errorMessages.push(`${formattedField} - ${formattedSubField}: ${subMessage}`);
      });
    } else if (typeof value === 'string') {
      errorMessages.push(`${formattedField}: ${value}`);
    }
  });
  
  return errorMessages.join(', ') || 'Please fill in all required fields';
}


type Token= {
  type: 'key';
  value: string;
} | {
  type: 'index';
  value: number;
}


/**
 * 
 * @param path This is the path of the value that caused the Graphql type check to fail 
 * @returns A list of object keys and array key indexes that leads to the value
 */
export function parseJsonPath(path: string): Token[] {
  // Remove the leading "$." if present
  const cleanPath = path.replace(/^\$\./, '');
  
  const tokens: Token[] = [];
  const parts = cleanPath.split('.');
  
  parts.forEach(part => {
  const matches = part.match(/^([^[]+)((?:\[\d+\])+)$/);

    if (matches) {
      tokens.push({
        type: 'key',
        value: matches[1]
      });
      
      const indices = matches[2].match(/\d+/g);
      indices?.forEach(index => {
        tokens.push({
          type: 'index',
          value: parseInt(index)
        });
      });
    } else {
      tokens.push({
        type: 'key',
        value: part
      });
    }
  });
  
  return tokens;
}

// utils/s3Upload.ts
export async function uploadToS3(
  file: File,
  uploadMutation: ReturnType<typeof useGenerate_Signeds3_Request_For_UploadMutation>[0]
): Promise<{ url: string; filename: string }> {
  try {
    const timestamp = Date.now();
    const filename = `${timestamp}-${file.name}`;

    console.log('🔵 Requesting signed URL for:', { filename, filetype: file.type });

    const { data } = await uploadMutation({
      variables: { filename, filetype: file.type },
    });

    if (!data?.generateSignedS3RequestForUpload) {
      throw new Error('No signed URL returned');
    }

    const { signedRequest, url } = data.generateSignedS3RequestForUpload;

    // ✅ Type guards
    if (!signedRequest || !url) {
      throw new Error('Missing signedRequest or url from backend');
    }

    console.log('🟢 Got signed URL:', { signedRequest, url });

    // Upload to S3 using the SIGNED REQUEST
    console.log('📤 Uploading to S3...');
    const uploadResponse = await fetch(signedRequest, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    console.log('📊 Upload response:', {
      status: uploadResponse.status,
      statusText: uploadResponse.statusText,
      ok: uploadResponse.ok
    });

    if (!uploadResponse.ok) {
      const errorText = await uploadResponse.text();
      console.error('❌ S3 Upload failed:', errorText);
      throw new Error(`S3 upload failed: ${uploadResponse.status} - ${errorText}`);
    }

    console.log('✅ Upload successful. File URL:', url);
    
    return { url, filename };

  } catch (error) {
    console.error('💥 Upload error:', error);
    throw error;
  }
}